import React from 'react'
import { Paragraph, Row, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { NoticeLoading } from '@fs/zion-icon'

export default function ProcessingFileText() {
  const [t] = useTranslation()

  return (
    <>
      <Separator size="nano" />
      <Row alignY="middle" guttersX="nano">
        <NoticeLoading noShrinkX />
        <Paragraph size="xs">{t('tree-import.file-processing.description')}</Paragraph>
      </Row>
    </>
  )
}
